import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.audio = null
    this.playing = false

    // Listen for stop events from parent containers
    this.handleStop = this.stop.bind(this)
    this.element.addEventListener("audio:stop", this.handleStop)
  }

  stop() {
    if (this.audio && this.playing) {
      this.audio.pause()
      this.audio.currentTime = 0
      this.playing = false
      this.updateIcon(false)
    }
  }

  play(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.playing && this.audio) {
      this.audio.pause()
      this.audio.currentTime = 0
      this.playing = false
      this.updateIcon(false)
      return
    }

    if (!this.audio) {
      this.audio = new Audio(this.urlValue)
      this.audio.addEventListener('ended', () => {
        this.playing = false
        this.updateIcon(false)
      })
      this.audio.addEventListener('error', () => {
        console.error('Error loading audio')
        this.playing = false
        this.updateIcon(false)
      })
    }

    this.audio.play().catch((error) => {
      console.error('Error playing audio:', error)
    })
    this.playing = true
    this.updateIcon(true)
  }

  updateIcon(playing) {
    const icon = this.element.querySelector('[data-lucide]')
    if (icon) {
      icon.setAttribute('data-lucide', playing ? 'pause' : 'volume-2')
      if (typeof lucide !== 'undefined') {
        lucide.createIcons({ nodes: [icon] })
      }
    }
  }

  disconnect() {
    this.element.removeEventListener("audio:stop", this.handleStop)
    if (this.audio) {
      this.audio.pause()
      this.audio = null
    }
  }
}
